import React from 'react';
import ModalX from '../../components/modal-x';

const TermsOfServiceModal = ({ isOpen, onClose }) => {
    return (
        <ModalX
            isOpen={isOpen}
            onClose={onClose}
            maxWidth="xxxl"
            title="Terms of Service"
        >
            <div className="prose prose-sm max-w-none">
                <div className="text-sm text-gray-700 space-y-4">
                    <p className="font-semibold text-lg">Pulse Workspace Management System</p>

                    <div>
                        <h3 className="font-semibold text-base text-gray-900 mb-2">1. Acceptance of Terms</h3>
                        <p className="text-gray-600 mb-3">
                            By accessing and using Pulse Workspace Management System ("Pulse," "Service," "we," "our," or "us"),
                            you accept and agree to be bound by the terms and provision of this agreement.
                        </p>
                        <p className="text-gray-600">
                            If you do not agree to abide by the above, please do not use this service.
                        </p>
                    </div>

                    <div>
                        <h3 className="font-semibold text-base text-gray-900 mb-2">2. Description of Service</h3>
                        <p className="text-gray-600 text-xs">
                            Pulse provides a comprehensive workspace management platform that includes:
                            office and seat booking systems, contract management, customer relationship management,
                            meeting room reservations, billing and payment processing, and related business operations.
                        </p>
                    </div>

                    <div>
                        <h3 className="font-semibold text-base text-gray-900 mb-2">3. User Accounts and Responsibilities</h3>
                        <div className="ml-4 space-y-2">
                            <div>
                                <h4 className="font-medium text-gray-800">3.1 Account Creation</h4>
                                <p className="text-gray-600 text-xs">
                                    You must provide accurate, current, and complete information during registration.
                                    You are responsible for safeguarding your account credentials and for all activities
                                    that occur under your account.
                                </p>
                            </div>
                            <div>
                                <h4 className="font-medium text-gray-800">3.2 Acceptable Use</h4>
                                <p className="text-gray-600 text-xs">
                                    You agree to use the Service only for lawful purposes and in accordance with these Terms.
                                    You must not use the Service to transmit harmful, offensive, or illegal content.
                                </p>
                            </div>
                            <div>
                                <h4 className="font-medium text-gray-800">3.3 Prohibited Activities</h4>
                                <p className="text-gray-600 text-xs">
                                    You may not attempt to gain unauthorized access to the Service, interfere with
                                    its operation, or use it for any commercial purpose without our written consent.
                                </p>
                            </div>
                        </div>
                    </div>

                    <div>
                        <h3 className="font-semibold text-base text-gray-900 mb-2">4. Workspace Bookings and Contracts</h3>
                        <div className="ml-4 space-y-2">
                            <div>
                                <h4 className="font-medium text-gray-800">4.1 Booking Terms</h4>
                                <p className="text-gray-600 text-xs">
                                    All workspace bookings are subject to availability and our booking policies.
                                    We reserve the right to modify or cancel bookings in accordance with our terms.
                                </p>
                            </div>
                            <div>
                                <h4 className="font-medium text-gray-800">4.2 Contract Obligations</h4>
                                <p className="text-gray-600 text-xs">
                                    Users must comply with all terms and conditions specified in their workspace contracts,
                                    including payment schedules, usage restrictions, and termination procedures.
                                </p>
                            </div>
                            <div>
                                <h4 className="font-medium text-gray-800">4.3 Payment Terms</h4>
                                <p className="text-gray-600 text-xs">
                                    All fees and charges are due as specified in your contract. Late payments may result
                                    in service suspension or contract termination.
                                </p>
                            </div>
                        </div>
                    </div>

                    <div>
                        <h3 className="font-semibold text-base text-gray-900 mb-2">5. Privacy and Data Protection</h3>
                        <p className="text-gray-600 text-xs">
                            Your privacy is important to us. Our collection and use of personal information
                            is governed by our Privacy Policy, which is incorporated into these Terms by reference.
                        </p>
                    </div>

                    <div>
                        <h3 className="font-semibold text-base text-gray-900 mb-2">6. Intellectual Property</h3>
                        <p className="text-gray-600 text-xs">
                            The Service and its original content, features, and functionality are owned by Pulse
                            and are protected by international copyright, trademark, patent, trade secret,
                            and other intellectual property laws.
                        </p>
                    </div>

                    <div>
                        <h3 className="font-semibold text-base text-gray-900 mb-2">7. Limitation of Liability</h3>
                        <p className="text-gray-600 text-xs">
                            In no event shall Pulse be liable for any indirect, incidental, special, consequential,
                            or punitive damages, including without limitation, loss of profits, data, use, goodwill,
                            or other intangible losses resulting from your use of the Service.
                        </p>
                    </div>

                    <div>
                        <h3 className="font-semibold text-base text-gray-900 mb-2">8. Termination</h3>
                        <p className="text-gray-600 text-xs">
                            We may terminate or suspend your account and access to the Service immediately,
                            without prior notice, for any reason, including breach of these Terms.
                        </p>
                    </div>

                    <div>
                        <h3 className="font-semibold text-base text-gray-900 mb-2">9. Governing Law</h3>
                        <p className="text-gray-600 text-xs">
                            These Terms shall be governed by and construed in accordance with the laws of Pakistan,
                            without regard to its conflict of law provisions.
                        </p>
                    </div>

                    <div>
                        <h3 className="font-semibold text-base text-gray-900 mb-2">10. Contact Information</h3>
                        <p className="text-gray-600 text-xs">
                            If you have questions about these Terms of Service, please contact us
                            at <a href="mailto:info@workbench.pk" className="text-orange-500">info@workbench.pk</a> or through our support channels.
                        </p>
                    </div>

                    <div className="text-center pt-4">
                        <p className="text-xs text-gray-500">
                            This is a summary of our Terms of Service. For the complete terms, please visit our website.
                        </p>
                    </div>
                </div>
            </div>
        </ModalX>
    );
};

export default TermsOfServiceModal;
